import { formatDistanceStrict, isValid } from 'date-fns';

const shortDistanceLocale: Record<string, string> = {
  xSeconds: '{{count}} s',
  xMinutes: '{{count}} m',
  xHours: '{{count}} h',
  xDays: '{{count}} d',
  xMonths: '{{count}} mo',
  xYears: '{{count}} y',
};

const formatShortDistance = (
  token: string,
  count: number,
  options?: { addSuffix?: boolean; comparison?: number }
): string => {
  const template = shortDistanceLocale[token] || '{{count}}';
  const result = template.replace('{{count}}', String(count));

  if (options?.addSuffix) {
    if ((options.comparison || 0) > 0) {
      return `in ${result}`;
    }
    return `${result} ago`;
  }

  return result;
};

/**
 * Compact relative time for notification cards (e.g. "4 h ago", "3 m ago").
 */
export const formatNotificationRelativeTime = (
  timestamp: string | Date,
  now: Date = new Date()
): string | null => {
  const parsed = timestamp instanceof Date ? timestamp : new Date(timestamp);
  if (!isValid(parsed)) {
    return null;
  }

  return formatDistanceStrict(parsed, now, {
    addSuffix: true,
    locale: {
      formatDistance: formatShortDistance,
    },
  });
};
